import moment from 'moment';

export default function datetimeFormatter(value){
  if(!value)
  {
    return 'N/A';
  }
  return moment(String(value)).format('DD/MM/YYYY HH:mm');
}
